import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=907d2bf6&"
import script from "./InputRadio.vue?vue&type=script&lang=js&"
export * from "./InputRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports